<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <h5><span class="far fa-cabinet-filing mb-2"></span> Log de Erros</h5>
        </li>
        <li>
          <div>
        <span class="m-quick-sidebar__close mt-1" @click="closeThis()">
          <i class="fal fa-times-circle fa-lg"></i>
        </span>
      </div>
        </li>
      </ul>
      
      <div class="tab-content">
        <table class="table table-striped- table-bordered table-hover table-checkable">
          <tbody>
            <tr v-for="(log, id) in showLogError" :key="id">
              <td class="text-center">
                {{ log.log }}
              </td>
              <td class="text-center">
                {{ log.created_at }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogBillingHistoryModal',
  components: {},
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showLogError = null;
      this.$parent.callData();
    },
    console(){
      console.log(this.showLogError);
    }
  },
  computed: {
    showLogError() {
      return this.$store.state.showLogError;
    },
  },
};
</script>
